import { WhatsNewOpenModeType } from "__generated__/graphql";

export const whatsNewModalActions = {
  SHOW_WHATS_NEW_MODAL: 'SHOW_WHATS_NEW_MODAL',
  TOGGLE_WHATS_NEW_MODAL: 'TOGGLE_WHATS_NEW_MODAL',
  SET_WHATS_NEW_OPEN_MODE: 'SET_WHATS_NEW_OPEN_MODE',

  showWhatsNewModal: (payload: boolean) => ({
    type: whatsNewModalActions.SHOW_WHATS_NEW_MODAL,
    payload,
  }),

  toggleWhatsNewModal: () => ({
    type: whatsNewModalActions.TOGGLE_WHATS_NEW_MODAL,
  }),

  setWhatsNewOpenMode: (payload: WhatsNewOpenModeType) => ({
  type: whatsNewModalActions.SET_WHATS_NEW_OPEN_MODE,
  payload,
  }),
};